import React, { useEffect, useState } from "react";
import { createCouponService, getOtherTransport } from "../../../services/apiService";



const HeavyPrintOrder = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      setLoading(true);
      const res = await getOtherTransport();
      console.log(res);
      setData(res.data || []);
    } catch (error) {
      console.error("Packing list error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <h3 style={{ textAlign: "center", color: "green" }}>
        Heavy Print Order
      </h3>
      {loading ? (
        <p>Loading orders...</p>
      ) : (
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ background: "#f3f4f6" }}>
              <th style={thStyle}>Order ID</th>
              <th style={thStyle}>OrderDate</th>
              <th style={thStyle}>FirstName</th>
              <th style={thStyle}>Mobile</th>
              <th style={thStyle}>FirmName</th>
              <th style={thStyle}>NetAmount</th>
              <th style={thStyle}>Transport</th>
              <th style={thStyle}>Post</th>
              <th style={thStyle}>Actions</th>
              <th style={thStyle}>HeavyPrint</th>
            </tr>
          </thead>
          <tbody>
            {data.length === 0 ? (
              <tr>
                <td colSpan="10" style={{ textAlign: "center", padding: 12 }}>
                  No orders found
                </td>
              </tr>
            ) : (
              data.map((item, index) => (
                <tr key={index}>
                  <td style={tdStyle}>{index}</td>
                  <td style={tdStyle}>₹{index}</td>
                  <td style={tdStyle}>     </td>
                  <td style={tdStyle}>     </td>
                  <td style={tdStyle}>     </td>
                  <td style={tdStyle}>     </td>
                  <td style={tdStyle}>     </td>
                  <td style={tdStyle}>     </td>
                  <td style={tdStyle}>     </td>
                  <td style={tdStyle}>     </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      )}

    </div>
  );
};
const thStyle = {
  padding: "10px",
  border: "1px solid #ddd",
  textAlign: "left",
  fontSize: 14,
};

const tdStyle = {
  padding: "10px",
  border: "1px solid #ddd",
  fontSize: 13,
};


export default HeavyPrintOrder;
